const advisorBioDetail = {
  displayField: 'title',
  name: 'Advisor Bio Detail',
  description: 'Advisor bio detail page',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'advisorBioDetail',
    version: 2,
    updatedAt: '2023-04-03T20:44:01.366Z'
  }
};
export default advisorBioDetail;